// 受け付ける動画（サーバー側 services/admin_ops.py の OPS_VIDEO_CONTENT_TYPES と同期させること）
const VIDEO_TYPES = { '.mp4': 'video/mp4', '.webm': 'video/webm' };
// 添付だけ受け付ける動画（ブラウザで最適化して .mp4 にしてから送る）
const INPUT_ONLY_TYPES = { '.mov': 'video/quicktime' };

export const VIDEO_ACCEPT = 'video/mp4,video/webm,video/quicktime,.mp4,.webm,.mov';
export const VIDEO_FORMAT_LABEL = 'MP4 / WebM';

// 音声トラックがあるときの注意文言（最適化しない動画だけに出す。最適化すると音声は削除される）
export const AUDIO_WARN_INLINE = `音声付きです。音声なし・最適化済みの ${VIDEO_FORMAT_LABEL} に差し替えてください`;

const FOUR_BYTE = /[\u{10000}-\u{10FFFF}]/u;

/**
 * 添付できる動画か（拡張子 .mp4 / .webm / .mov で判定する。.mov は最適化して .mp4 で送る）
 * ファイル名はサーバーの utf8mb3 の列に入るため、4バイト文字を含む名前は不可
 */
export const isSupportedVideoFile = (file) => {
    if (!file || !file.name) return false;
    if (FOUR_BYTE.test(file.name)) return false;
    const dot = file.name.lastIndexOf('.');
    return dot > 0 && Object.keys({ ...VIDEO_TYPES, ...INPUT_ONLY_TYPES }).includes(file.name.slice(dot).toLowerCase());
};

export const prettySize = (n) => {
    if (!n) return '-';
    if (n < 1024) return n + ' B';
    if (n < 1048576) return (n / 1024).toFixed(1) + ' KB';
    return (n / 1048576).toFixed(1) + ' MB';
};

/**
 * 動画に音声トラックがあるかを <video> のメタデータで判定する（判定できなければ null）
 * @returns {Promise<boolean|null>}
 */
export const checkVideoHasAudio = (file) => new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.muted = true;
    const done = (has) => {
        URL.revokeObjectURL(url);
        resolve(has);
    };
    video.addEventListener('loadedmetadata', () => {
        // audioTracks は Safari、mozHasAudio は Firefox、webkitAudioDecodedByteCount は Chrome（再生前は判定できない）
        if (video.audioTracks) done(video.audioTracks.length > 0);
        else if (video.mozHasAudio !== undefined) done(!!video.mozHasAudio);
        else done(null);
    }, { once: true });
    video.addEventListener('error', () => done(null), { once: true });
    video.src = url;
});

// SAS の動画を新しいタブで再生する（ダウンロード扱いにならないよう video 要素で開く）
export const openVideoInNewTab = (url, title) => {
    const win = window.open('', '_blank');
    if (!win) return;
    const doc = win.document;
    doc.title = title || '動画';
    doc.body.style.cssText = 'margin:0;background:#000;display:flex;align-items:center;justify-content:center;height:100vh';
    const video = doc.createElement('video');
    video.src = url;
    video.controls = true;
    video.autoplay = true;
    video.style.cssText = 'max-width:100%;max-height:100%';
    doc.body.appendChild(video);
};
